import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sticky from 'Components/Sticky';
import ClassNames from 'classnames';
import ActionLoader from 'Components/ActionLoader';
import { GET_GOOGLE_STUDIO_REPORT } from 'Constants/actionConstants';
import { isAdaniWilmar } from 'Utils/index';


class GoogleStudioReport extends Component {
    state = {
        isLoading: true
    }

    componentDidMount() {
        this.getReport();
    }

    getReport = () => {
        const { dispatch, report_id } = this.props;
        dispatch({
            type: GET_GOOGLE_STUDIO_REPORT,
            params: {
                report_id
            }
        })
    }
    
    showReports = () => {
        const { data } = this.props;
        return(
            <>
            {this.state.isLoading && <ActionLoader fixed={true}/>}
                {data.report_id && <iframe
                    src={data.src}
                    style={{width: "100%", height: 760}}
                    frameBorder="0"
                    onLoad={() => { this.setState({ isLoading: false }) }}
                    title={data.report_name}
                    allowFullScreen
                />}
            </>
        )
    }
    render() {
        
        return (
            <>
            {!isAdaniWilmar() ?
             <Sticky hideNavbar={this.props.hideNavbar}> {this.showReports()} </Sticky> :
             <> {this.showReports()} </>
            }
            </>    
        );
    }

}

const mapStateToProps = ({constants}) => {
  return {
    data: constants.googleStudioReport || {}
  }
};

export default connect(mapStateToProps)(GoogleStudioReport);

